import { AwsAccesses } from "@p0security/integrations-aws-shared/accesses";
import { Access, Delegate } from "@p0security/shared/types/access/index";

export const AwsSmAccesses = {
  secret: Access({
    label: "Secret",
    description: "Grant ability to read a secret",
    delegation: {
      aws: Delegate({
        resource: "aws",
        accesses: AwsAccesses,
        key: "resource",
      }),
    },
    generated: {},
    maturity: "preview" as const,
    parameters: {
      account: { type: "static", label: "Secret manager account" },
      region: { type: "static", label: "Secret region" },
      name: { type: "input", label: "Secret name" },
    },
    render: { locator: "account", policy: "name" } as const,
  }),
};

export type AwsSmAccesses = typeof AwsSmAccesses;
